import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { DeviceState } from '@era/appmanagement-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================
export const DeviceApplicationStateResolverActions = createActionGroup({
  source: 'Device Application State Resolver',
  events: {
    'Device Application States requested': emptyProps,
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================
export const DeviceApplicationStateApiActions = createActionGroup({
  source: 'Device Application State API',
  events: {
    'Device Application States loaded': props<{ states: DeviceState[] }>(),
    'Device Application States load failed': props<{ error: ErrorModel }>(),
  },
});
